import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_m_btn = _resolveComponent("m-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_data_table_server, {
                    "items-per-page": $setup.pageSize,
                    "onUpdate:itemsPerPage": _cache[2] || (_cache[2] = ($event: any) => (($setup.pageSize) = $event)),
                    headers: $setup.headers,
                    items: $setup.underwriters,
                    "items-length": $setup.totalCount,
                    loading: $setup.loading,
                    page: $setup.page,
                    "items-per-page-options": [10, 25, 50, 100],
                    density: "comfortable",
                    hover: "",
                    "onUpdate:options": $setup.onTableOptions
                  }, {
                    top: _withCtx(() => [
                      _createVNode(_component_v_toolbar, { flat: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_toolbar_title, null, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createTextVNode("Underwriter Management")
                            ])),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_v_divider, {
                            class: "mx-4",
                            inset: "",
                            vertical: ""
                          }),
                          _createVNode(_component_v_text_field, {
                            modelValue: $setup.lastNameSearch,
                            "onUpdate:modelValue": [
                              _cache[0] || (_cache[0] = ($event: any) => (($setup.lastNameSearch) = $event)),
                              $setup.searchDebounced
                            ],
                            label: "Search by last name",
                            "prepend-inner-icon": "mdi-magnify",
                            variant: "outlined",
                            density: "compact",
                            "hide-details": "",
                            clearable: "",
                            class: "mr-4 search-field",
                            onKeydown: _withKeys(_withModifiers($setup.searchNow, ["prevent"]), ["enter"])
                          }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "onKeydown"]),
                          _createVNode(_component_v_checkbox, {
                            modelValue: $setup.includeExpired,
                            "onUpdate:modelValue": [
                              _cache[1] || (_cache[1] = ($event: any) => (($setup.includeExpired) = $event)),
                              $setup.onFilterChange
                            ],
                            label: "Include Expired",
                            "hide-details": "",
                            class: "mr-4"
                          }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_v_chip, { class: "mr-2" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.totalCount) + " records", 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_m_btn, {
                            color: "primary",
                            "prepend-icon": "mdi-plus",
                            to: { path: '/SSAM/underwriters/new' }
                          }, {
                            default: _withCtx(() => _cache[6] || (_cache[6] = [
                              _createTextVNode(" Add Underwriter ")
                            ])),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    [`item.status`]: _withCtx(({ item }) => [
                      _createVNode(_component_v_chip, {
                        color: item.firstName?.toUpperCase().startsWith('Z ') ? 'warning' : (item.status === 'A' ? 'success' : 'default'),
                        size: "small",
                        label: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.firstName?.toUpperCase().startsWith('Z ') ? 'Expired' : (item.status === 'A' ? 'Active' : item.status)), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color"])
                    ]),
                    [`item.profile`]: _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(item.profile?.toUpperCase()), 1 /* TEXT */)
                    ]),
                    [`item.lastName`]: _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(item.lastName?.toUpperCase()), 1 /* TEXT */)
                    ]),
                    [`item.firstName`]: _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(item.firstName?.toUpperCase()), 1 /* TEXT */)
                    ]),
                    [`item.middleName`]: _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(item.middleName?.toUpperCase()), 1 /* TEXT */)
                    ]),
                    [`item.userGroupProfile`]: _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(item.userGroupProfile?.toUpperCase()), 1 /* TEXT */)
                    ]),
                    [`item.actions`]: _withCtx(({ item }) => [
                      _createVNode(_component_v_btn, {
                        variant: "tonal",
                        color: "warning",
                        size: "small",
                        "prepend-icon": "mdi-archive-arrow-down-outline",
                        "aria-label": `Expire ${item.profile}`,
                        onClick: ($event: any) => ($setup.confirmExpire(item))
                      }, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createTextVNode(" Expire ")
                        ])),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["aria-label", "onClick"])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["items-per-page", "headers", "items", "items-length", "loading", "page", "onUpdate:options"])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_v_dialog, {
        modelValue: $setup.showExpireDialog,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.showExpireDialog) = $event)),
        "max-width": "480"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "text-h6" }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("Expire underwriter?")
                ])),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _cache[9] || (_cache[9] = _createTextVNode(" This marks ")),
                  _createElementVNode("strong", null, _toDisplayString($setup.pendingExpire?.profile?.toUpperCase()), 1 /* TEXT */),
                  _cache[10] || (_cache[10] = _createTextVNode(" as expired by prefixing the first name with ")),
                  _cache[11] || (_cache[11] = _createElementVNode("strong", null, "\"Z \"", -1 /* HOISTED */)),
                  _cache[12] || (_cache[12] = _createTextVNode(" (for example, ")),
                  _cache[13] || (_cache[13] = _createElementVNode("em", null, "DAVID OAKE", -1 /* HOISTED */)),
                  _cache[14] || (_cache[14] = _createTextVNode(" becomes ")),
                  _cache[15] || (_cache[15] = _createElementVNode("em", null, "Z DAVID OAKE", -1 /* HOISTED */)),
                  _cache[16] || (_cache[16] = _createTextVNode("). The entry is then hidden from the list unless ")),
                  _cache[17] || (_cache[17] = _createElementVNode("em", null, "Include Expired", -1 /* HOISTED */)),
                  _cache[18] || (_cache[18] = _createTextVNode(" is checked. "))
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_m_btn, {
                    disabled: $setup.expiring,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.showExpireDialog = false))
                  }, {
                    default: _withCtx(() => _cache[19] || (_cache[19] = [
                      _createTextVNode("Cancel")
                    ])),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["disabled"]),
                  _createVNode(_component_m_btn, {
                    color: "warning",
                    loading: $setup.expiring,
                    onClick: $setup.executeExpire
                  }, {
                    default: _withCtx(() => _cache[20] || (_cache[20] = [
                      _createTextVNode("Expire")
                    ])),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["loading", "onClick"])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue"])
    ]),
    _: 1 /* STABLE */
  }))
}